module.exports = __webpack_public_path__ + "media/tts_g1_a.2b71f846.mp3";